import React from "react";
import { Link } from "react-router-dom";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "./Signup.css";
import signupVideo from "../../assets/videos/signupVideo.mp4";

const SignupPage1: React.FC = () => {
  return (
    <div className="signup-page-container">
      {/* <ProgressBar progress={20} /> */}
      <div className="signup-content">
        <video
          className="signup-video"
          src={signupVideo}
          autoPlay
          loop
          muted
          playsInline
        />
        <h1 className="signup-mainpage-heading">
          Begin Sculpting Your Weight Loss Journey
        </h1>
        <p className="signup-mainpage-para">
          Unlock your personalized journey towards your{" "}
          <span className="optimal">optimal self</span>.
        </p>
        <Link to="/signup/page1">
          <button className="next-btn">Get Started</button>
        </Link>
        <p className="terms-and-conditions">
          By clicking 'Get Started,' you agree to our
          <span className="terms"> Terms of Service</span> and acknowledge our
          <span className="privacy-policy"> Privacy Policy</span>.
        </p>
      </div>
    </div>
  );
};

export default SignupPage1;
